// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.unread .subject, .unread .email-date {
  font-weight: 700 !important;
  color: var(--linkColour);
}

.from-address, .sent-date {
  font-size: 0.75rem;
  font-weight: 400;
}

.email-body {
  font-size: 0.75rem;
  font-weight: 500;
}

.email-list {
  background-color: #f8f8f8;
  overflow-y: auto;
  box-sizing: border-box;
}

.button-style {
  min-width: 70px;
  margin-right: 5px;
  margin-bottom: 5px;
}

.mail-view {
  padding: 15px 20px 20px 20px;
}
.mail-view .body {
  margin-top: 10px;
  font-size: 18px;
}

.striped-div {
  border-bottom: 1px solid #dfdfdf;
}
.striped-div:hover {
  background-color: #f4f4f4;
}

.selected .header-line {
  background-color: #cde6f7;
  border: 1px solid #cfcfcf;
}

.header-line.info-line .from-col, .header-line.info-line .info-col {
  font-size: 0.75rem;
  font-weight: 400;
}

.from-col {
  font-size: 0.75rem;
  padding-left: 10px;
  font-weight: 400;
  white-space: nowrap;
  overflow: hidden;
}
.from-col .from-col-inner {
  border-right: 1px solid #e4e4e4;
}

.info-col {
  font-size: 0.75rem;
  font-weight: 400;
  padding-left: 20px;
}
.info-col .info-inner {
  border-right: 1px solid #e4e4e4;
}
.info-col .sender-from {
  font-weight: 400;
}
.info-col .sender-subject {
  font-weight: 600;
}
.info-col .subject {
  font-weight: 600;
  color: var(--linkColour);
  line-height: 17px;
}

.date-col {
  font-size: 0.75rem;
  font-weight: 400;
  text-align: center;
  padding-right: 10px;
  display: flex;
  text-align: right;
  align-items: center;
  height: 100%;
}
.date-col .email-date {
  flex-grow: 1;
  text-align: right;
}

.envelope-icon {
  display-inline: block;
  width: 12px;
  margin-right: 5px;
}`, "",{"version":3,"sources":["webpack://./projects/remarq/src/app/components/main/inmail-folder/inmail-folder.component.scss"],"names":[],"mappings":"AAEE;EACE,2BAAA;EACA,wBAAA;AADJ;;AAMA;EACE,kBAAA;EACA,gBAAA;AAHF;;AAMA;EACE,kBAAA;EACA,gBAAA;AAHF;;AAOA;EACE,yBAAA;EACA,gBAAA;EACA,sBAAA;AAJF;;AAOA;EAEE,eAAA;EACA,iBAAA;EACA,kBAAA;AALF;;AASA;EAEE,4BAAA;AAPF;AASE;EACE,gBAAA;EACA,eAAA;AAPJ;;AAYA;EACE,gCAAA;AATF;AAWE;EACE,yBAAA;AATJ;;AAgBA;EACE,yBAAA;EACA,yBAAA;AAbF;;AAkBE;EACE,kBAAA;EACA,gBAAA;AAfJ;;AAoBA;EACE,kBAAA;EACA,kBAAA;EACA,gBAAA;EACA,mBAAA;EACA,gBAAA;AAjBF;AAmBE;EACE,+BAAA;AAjBJ;;AAsBA;EAEE,kBAAA;EACA,gBAAA;EAEA,kBAAA;AArBF;AAuBE;EACE,+BAAA;AArBJ;AAwBE;EACE,gBAAA;AAtBJ;AAyBE;EACE,gBAAA;AAvBJ;AA0BE;EACE,gBAAA;EACA,wBAAA;EACA,iBAAA;AAxBJ;;AA4BA;EACE,kBAAA;EACA,gBAAA;EACA,kBAAA;EACA,mBAAA;EACA,aAAA;EACA,iBAAA;EACA,mBAAA;EACA,YAAA;AAzBF;AA2BE;EACE,YAAA;EACA,iBAAA;AAzBJ;;AA6BA;EACE,qBAAA;EACA,WAAA;EACA,iBAAA;AA1BF","sourcesContent":[".unread {\n\n  .subject, .email-date {\n    font-weight: 700 !important;\n    color: var(--linkColour);\n  }\n\n}\n\n.from-address, .sent-date {\n  font-size: 0.75rem;\n  font-weight: 400;\n}\n\n.email-body {\n  font-size: 0.75rem;\n  font-weight: 500;\n\n}\n\n.email-list {\n  background-color: #f8f8f8;\n  overflow-y: auto;\n  box-sizing: border-box;\n}\n\n.button-style {\n\n  min-width: 70px;\n  margin-right: 5px;\n  margin-bottom: 5px;\n\n}\n\n.mail-view {\n\n  padding: 15px 20px 20px 20px;\n\n  .body {\n    margin-top: 10px;\n    font-size: 18px;\n  }\n}\n\n\n.striped-div {\n  border-bottom: 1px solid #dfdfdf;\n\n  &:hover {\n    background-color: #f4f4f4;\n  }\n}\n\n.striped-div-table {\n}\n\n.selected .header-line {\n  background-color: #cde6f7;\n  border: 1px solid #cfcfcf;\n}\n\n.header-line.info-line {\n\n  .from-col, .info-col {\n    font-size: 0.75rem;\n    font-weight: 400;\n  }\n\n}\n\n.from-col {\n  font-size: 0.75rem;\n  padding-left: 10px;\n  font-weight: 400;\n  white-space: nowrap;\n  overflow: hidden;\n\n  .from-col-inner {\n    border-right: 1px solid #e4e4e4;\n  }\n}\n\n\n.info-col {\n\n  font-size: 0.75rem;\n  font-weight: 400;\n\n  padding-left: 20px;\n\n  .info-inner {\n    border-right: 1px solid #e4e4e4;\n  }\n\n  .sender-from {\n    font-weight: 400;\n  }\n\n  .sender-subject {\n    font-weight: 600;\n  }\n\n  .subject {\n    font-weight: 600;\n    color: var(--linkColour);\n    line-height: 17px;\n  }\n}\n\n.date-col {\n  font-size: 0.75rem;\n  font-weight: 400;\n  text-align: center;\n  padding-right: 10px;\n  display: flex;\n  text-align: right;\n  align-items: center;\n  height: 100%;\n\n  .email-date {\n    flex-grow: 1;\n    text-align: right;\n  }\n}\n\n.envelope-icon {\n  display-inline: block;\n  width: 12px;\n  margin-right: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
